import type { Metadata } from "next";
import { MinimalHeader } from "@/components/headers/minimal-header";
import { SlimFooter } from "@/components/footers/slim-footer";
import { NotFoundContent } from "@/components/not-found-content";

export const metadata: Metadata = {
  title: "Page not found",
  description: "The page you were looking for could not be found.",
  robots: { index: false, follow: false },
};

export default function NotFound() {
  return (
    <div className="flex min-h-dvh flex-col">
      <MinimalHeader />
      <main id="main" className="flex-1">
        <NotFoundContent />
      </main>
      <SlimFooter />
    </div>
  );
}
